export const namePattern = "^[a-zA-Z\\u0590-\\u05fe'\\-]+$";
export const fullNamePattern = "^[a-zA-Z\\u0590-\\u05fe'\\- ]+$";

export function onInputNameHandler(event: React.FormEvent<HTMLInputElement>) {
  const input = event.currentTarget;

  const valueTrimmed = input.value.trim();

  if (!valueTrimmed) input.value = '';
}
